import Button from '../Form/Button';

import { Container } from './styles';

interface ErroConsultaProps {
  mensagem?: string;
  onTentarNovamente?: () => void;
}

// Aviso padrao quando a consulta ao Protheus falha (queda do link com a
// Capul, timeout, erro do servidor). Antes as telas nao tratavam o erro e
// mostravam lista vazia, "0 registros" ou os placeholders dos campos como se
// fossem o dado real do cooperado.
function ErroConsulta({
  mensagem = 'Não foi possível consultar os dados no momento. Tente novamente em instantes.',
  onTentarNovamente,
}: ErroConsultaProps) {
  return (
    <Container>
      <p>{mensagem}</p>
      {onTentarNovamente && (
        <Button onClick={onTentarNovamente}>Tentar novamente</Button>
      )}
    </Container>
  );
};

export default ErroConsulta;
